import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { AssetDownloadPage } from './pages/AssetDownloadPage';
export function App() {
  // Simple client-side routing based on pathname
  const path = window.location.pathname;
  if (path === '/1') {
    return <AssetDownloadPage data-id="element-0" />;
  }
  return <LandingPage data-id="element-1" />;
}